import React from 'react';
import I18n from 'i18n-js';
import classNames from 'classnames';
import { RCTooltip } from '@reverbdotcom/cadence/components';
import { B_STOCK, BRAND_NEW, MINT_INVENTORY } from '../condition_helpers';

interface Props {
  slug: string;
  displayName: string;
  showTooltip?: boolean;
  /** @deprecated unused. This is now the default display style */
  textOnly?: boolean;
  displayAsTag?: boolean;
  isDigitalListing?: boolean;
}

export function conditionDisplayText(slug: string, displayName: string): string {
  if (slug === BRAND_NEW || slug === B_STOCK) return displayName;
  return I18n.t('commons.conditionDisplay.used', { condition: displayName });
}

export default function ConditionDisplay({
  slug,
  displayName,
  showTooltip = false,
  textOnly = true,
  displayAsTag = false,
  isDigitalListing = false,
}: Props) {
  const normalizedSlug = slug === MINT_INVENTORY ? 'mint' : slug;
  const text = conditionDisplayText(normalizedSlug, displayName);
  const label = !showTooltip ? text : (
    <RCTooltip
      text={I18n.t(`commons.specList.conditions.${slug}`)}
      type={textOnly ? 'underline' : 'plain'}
      placement="top"
    >
      {text}
    </RCTooltip>
  );

  if (!displayName) return null;

  if (isDigitalListing) return null;

  const classes = classNames(
    'condition-display',
    { 'condition-display--tag': displayAsTag },
  );

  return (
    <div className={classes}>
      <div className="condition-display__label">
        {label}
      </div>
    </div>
  );
}
